import { useState, useRef } from 'react';
import api from '../api';

export default function useUserProfile({ userProfile, onProfileUpdated, onClose, showToast }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(null);
  const fileRef = useRef(null);

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      showToast('Please select an image file', 'error');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      showToast('Image must be under 5MB', 'error');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => setPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleUpload = async () => {
    const file = fileRef.current?.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      await api.uploadProfilePicture(userProfile.uid, file);
      showToast('Profile picture updated', 'success');
      onProfileUpdated();
      onClose();
    } catch (err) {
      showToast(err.message || 'Failed to upload picture', 'error');
    } finally {
      setUploading(false);
    }
  };

  const handleCancel = () => {
    setPreview(null);
    if (fileRef.current) fileRef.current.value = '';
  };

  return {
    uploading,
    preview,
    fileRef,
    handleFileSelect,
    handleUpload,
    handleCancel,
  };
}
